import React from 'react';
import { IComponentVideo } from '../../component';
import Video from './Video';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

interface IAllForVideo extends IComponentVideo {
  rootStore?: RootStore;
}
const AllForVideo = function(props: IAllForVideo) {
  const { uiStore, galleryStore } = props.rootStore!;
  const { mediaList } = galleryStore;
  const { showBasicDialog } = uiStore;

  return (
    <div className="all-for-video">
      <Video {...props} mediaList={mediaList} showDialog={showBasicDialog} />
    </div>
  );
};

export default inject('rootStore')(observer(AllForVideo));
